import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { colors, distances } from '../../../../styles/constants';
import Page from '../../../../components/Page';
import { LoadingOverlay } from '../../../../components/Loading';
import { H1 } from '../../../../components/Typography';
import Details from './Details';
import Delay from '../../../../components/Delay';
import { useAccount } from '../../hooks';

const AccountPage = () => {
    const { t } = useTranslation('app');
    const { account, isLoading } = useAccount();
    return (
        <Page title={<Title>{t('settings.account.title')}</Title>}>
            <Wrapper>
                {account && <Details account={account} isLoading={isLoading} />}
                {isLoading && <LoadingOverlay />}
            </Wrapper>
        </Page>
    );
};

const Wrapper = styled.div`
    position: relative;
    min-height: calc(${distances.ginormous} + ${distances.large});
`;

const Title = styled(H1)`
    color: ${colors.text};
    display: inline-block;
`;

export default AccountPage;
